import { Brand } from 'src/shared/enums/brand';
import { Language } from 'src/shared/enums/language';

export const companyName: Partial<Record<Brand, string>> = {
  [Brand.DL_IRELAND]: 'David Lloyd Riverview Operations Ireland Ltd',
  [Brand.DL_SPAIN]: 'David Lloyd Leisure España II SL',
  [Brand.DL_NETHERLANDS]: 'David Lloyd Health & Fitness BV',
  [Brand.DL_FRANCE]: 'David Lloyd Clubs France SAS',
  [Brand.DL_ITALY]: 'David Lloyd Leisure Limited',
  [Brand.DL_GERMANY]: 'David Lloyd Leisure Limited',
  [Brand.DL_BELGIUM]: 'David Lloyd Leisure Operations SPRL',
  [Brand.DL_UK]: 'David Lloyd Leisure Ltd.',
  [Brand.HARBOUR]: 'Harbour Club Ltd.',
  [Brand.MERIDIAN]: 'Meridian Spa & Fitness Deutschland GmbH',
};

export const VATNumber: Partial<Record<Brand, string>> = {
  [Brand.DL_IRELAND]: '9698607P',
  [Brand.DL_SPAIN]: '740 5477 34',
  [Brand.DL_NETHERLANDS]: 'NL807614464 B01',
  [Brand.DL_FRANCE]: '740 5477 34',
  [Brand.DL_ITALY]: '740 5477 34',
  [Brand.DL_GERMANY]: '740 5477 34',
  [Brand.DL_BELGIUM]: 'ESB83632692',
  [Brand.DL_UK]: '740 5477 34',
  [Brand.HARBOUR]: '740 5477 34',
  [Brand.MERIDIAN]: 'DE 226207486',
};

export const addressEU: Partial<Record<Brand, string>> = {
  [Brand.DL_IRELAND]:
    'David Lloyd Leisure Operations Ireland Ltd\n' +
    'Registered in Ireland, Company No. 464260.\n' +
    'Beech Hill, Clonskeagh, Dublin 4.',
  [Brand.DL_SPAIN]: '10ª. Avda. Diagonal, 673-685\n' + '08028 Barcelona\n' + 'España\n' + '\n',
  [Brand.DL_NETHERLANDS]: 'Peter Zuidlaan 30\n' + '5502 NH\n' + 'Veldhoven\n' + 'Nederland\n',
  [Brand.DL_FRANCE]:
    'David Lloyd City Green \n' + '740 route des Planlets \n' + '74140 Veigy-Foncenex, France\n',
  [Brand.DL_ITALY]:
    'Via dello Sport 1, San Felice\n' + 'Peschiera Borromeo\n' + '20068 MILANO, ITALY\n' + '\n',
  [Brand.DL_GERMANY]:
    'David Lloyd Clubs Germany GmbH\n' +
    'Niederstedter Weg 12\n' +
    '61348 Bad Homburg\n' +
    'Deutschland\n',
  [Brand.DL_BELGIUM]: '41 Dréve de Lorraine\n' + '1180 Uccle\n' + 'Belgique\n',
  [Brand.DL_UK]:
    'Registered Company No. 6261643\n' +
    'The Hangar, Mosquito Way, Hatfield Business Park\n' +
    'Hatfield, Hertfordshire, AL10 9AX\n',
  [Brand.HARBOUR]:
    'Registered Company No. 6261643\n' +
    'The Hangar, Mosquito Way, Hatfield Business Park\n' +
    'Hatfield, Hertfordshire, AL10 9AX\n',
  [Brand.MERIDIAN]: 'Wandsbeker Zollstr. 87-89\n' + '22041 Hamburg\n' + 'Deutschland',
};

export const brandPoliciesConfig = {
  [Brand.DL_SPAIN]: {
    privacyPolicyUrl: 'https://www.davidlloyd.es/policy/es-privacy-policy',
    termsAndConditionsUrl:
      'https://www.davidlloyd.es/-/media/david-lloyd/files/es-terms-and-conditions-october-2019.pdf',
  },
  [Brand.DL_BELGIUM]: {
    privacyPolicyUrl: 'https://www.davidlloyd.be/policy/be-privacy-policy',
    termsAndConditionsUrl:
      'https://www.davidlloyd.nl/-/media/david-lloyd/files/be-terms-and-conditions-october-2019.pdf',
  },
  [Brand.DL_UK]: {
    privacyPolicyUrl: 'https://www.davidlloyd.co.uk/policy/privacy-policy',
    termsAndConditionsUrl:
      'https://www.davidlloyd.co.uk/-/media/david-lloyd/files/uk-terms-and-conditions-october-2019-v2.pdf',
    cancellationPolicyUrl: {
      'en-gb': 'https://www.davidlloyd.co.uk/policy/uk-booking-policy',
    },
  },
  [Brand.DL_FRANCE]: {
    privacyPolicyUrl: 'https://www.davidlloyd.fr/policy/fr-privacy-policy',
    termsAndConditionsUrl:
      'https://www.davidlloyd.fr/-/media/david-lloyd/files/fr-terms-and-conditions-2019.pdf',
  },
  [Brand.DL_GERMANY]: {
    privacyPolicyUrl: 'https://www.davidlloyd.de/policy/de-privacy-policy',
    termsAndConditionsUrl:
      'https://www.davidlloyd.de/-/media/david-lloyd/files/de-terms-and-conditions-october-2019-v2.pdf',
  },
  [Brand.HARBOUR]: {
    privacyPolicyUrl: 'https://www.harbourclub.com/policy/privacy-policy',
    termsAndConditionsUrl:
      'https://www.harbourclub.com/-/media/harbour-club/files/membership-booklet/member-handbook-harbour-clubs.pdf',
    cancellationPolicyUrl: {
      'en-gb':
        'https://www.harbourclub.com/-/media/harbour-club/files/policy-docs/booking-policy-faqs-harbour-may19.pdf?la=en&hash=34A6C9488BB8C04923954E77B2518DA4DE5E460F',
    },
  },
  [Brand.DL_IRELAND]: {
    privacyPolicyUrl: 'https://www.davidlloyd.ie/policy/ie-privacy-policy',
    termsAndConditionsUrl:
      'https://www.davidlloyd.ie/-/media/david-lloyd/files/david-lloyd-ireland-terms-and-conditions-2019.pdf',
  },
  [Brand.DL_ITALY]: {
    privacyPolicyUrl: 'https://www.davidlloyd.it/policy/it-privacy-policy',
    termsAndConditionsUrl:
      'https://www.davidlloyd.it/-/media/david-lloyd/files/it-terms-and-conditions-october-2019.pdf',
  },
  [Brand.DL_NETHERLANDS]: {
    privacyPolicyUrl: 'https://www.davidlloyd.nl/policy/nl-privacy-policy',
    termsAndConditionsUrl:
      'https://www.davidlloyd.nl/-/media/david-lloyd/files/nl-terms-and-conditions-october-2019.pdf',
  },
  [Brand.MERIDIAN]: {
    privacyPolicyUrl: 'https://www.meridianspa.de/de-de/datenschutz',
    termsAndConditionsUrl:
      'https://www.meridianspa.de/allgemeine-geschaeftsbedingungen-meridian-spa-fitness/',
    cancellationPolicyUrl: {
      'en-gb': 'https://www.meridianspa.de/en/cancellation-policy',
      'de-de': 'https://www.meridianspa.de/de-de/cancellation-policy',
    },
  },
  [Brand.DL_SWITZERLAND]: {
    privacyPolicyUrl: 'https://www.davidlloyd.fr/policy/fr-privacy-policy',
    termsAndConditionsUrl:
      'https://www.davidlloyd.fr/-/media/david-lloyd/files/fr-terms-and-conditions-2019.pdf',
  },
};

export const getBrandFromDomainName = () => {
  const domain = window.location.hostname;

  switch (true) {
    case domain.endsWith('davidlloyd.co.uk'):
      return Brand.DL_UK;
    case domain.endsWith('davidlloyd.ie'):
      return Brand.DL_IRELAND;
    case domain.endsWith('davidlloyd.fr'):
      return Brand.DL_FRANCE;
    case domain.endsWith('davidlloyd.de'):
      return Brand.DL_GERMANY;
    case domain.endsWith('davidlloyd.it'):
      return Brand.DL_ITALY;
    case domain.endsWith('davidlloyd.nl'):
      return Brand.DL_NETHERLANDS;
    case domain.endsWith('davidlloyd.ch'):
      return Brand.DL_SWITZERLAND;
    case domain.endsWith('davidlloyd.be'):
      return Brand.DL_BELGIUM;
    case domain.endsWith('davidlloyd.es'):
      return Brand.DL_SPAIN;
    case domain.endsWith('meridianspa.de'):
      return Brand.MERIDIAN;
    case domain.endsWith('harbourclub.com'):
      return Brand.HARBOUR;
    default:
      return Brand.DL_UK;
  }
};

export const getLogoFromCurrentBrand = (brand: Brand) => {
  switch (brand) {
    case Brand.HARBOUR:
      return require('src/images/white-harbour-logo.png').default;
    case Brand.MERIDIAN:
      return require('src/images/meridian-logo-dark-bg.png').default;
    default:
      return require('src/images/david-lloyd-logo.png').default;
  }
};

export const getFontFamily = () => {
  const domain = window.location.hostname;
  switch (true) {
    case domain.endsWith('meridianspa.de'):
      return 'MuseoSansRounded500';
    case domain.endsWith('harbourclub.com'):
      return 'ITC Avant Garde Pro Bk';
    default:
      return 'inherit';
  }
};

export const getDefaultLanguageForBrand = (brand: Brand) => {
  switch (brand) {
    case Brand.DL_UK:
      return Language.EN_GB;
    case Brand.DL_SPAIN:
      return Language.ES_ES;
    case Brand.DL_NETHERLANDS:
      return Language.NL_BE;
    case Brand.DL_BELGIUM:
      return Language.NL_BE;
    case Brand.DL_ITALY:
      return Language.IT_IT;
    case Brand.DL_FRANCE:
      return Language.FR_BE;
    case Brand.DL_GERMANY:
      return Language.DE_DE;
    case Brand.MERIDIAN:
      return Language.DE_DE;
    case Brand.HARBOUR:
      return Language.EN_GB;
    default:
      return Language.EN_GB;
  }
};

export const infoFooter = {
  [Language.EN_GB]:
    'If you’d like to chat to one of the team, just head to the Help & Feedback section in the David Lloyd Clubs app and we’ll help from there.',
  [Language.FR_BE]:
    'Si vous souhaitez discuter avec un membre de l’équipe, rendez-vous dans la section Aide et Commentaires de l’application David Lloyd Clubs et nous vous aiderons à partir de là.',
  [Language.ES_ES]:
    'Si desea hablar con un miembro del equipo, diríjase a la sección Ayuda y Comentarios en la aplicación David Lloyd Clubs y le ayudaremos desde allí.',
  [Language.DE_DE]:
    'Wenn Sie mit einem Teammitglied sprechen möchten, gehen Sie einfach zum Bereich Hilfe & Feedback in der David Lloyd Clubs App und wir helfen Ihnen von dort aus weiter.',
  [Language.CA_ES]:
    'Si voleu parlar amb un membre de l’equip, aneu a la secció Ajuda i Comentaris a l’aplicació David Lloyd Clubs i us ajudarem des d’allà.',
  [Language.IT_IT]:
    'Se desidera parlare con un membro del team, acceda alla sezione Aiuto e Feedback nell’app David Lloyd Clubs e la aiuteremo da lì.',
  [Language.NL_BE]:
    'Als u met een van de teamleden wilt chatten, ga dan naar de sectie Help & Feedback in de David Lloyd Clubs-app en wij helpen u daar verder.',
};
